var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAz(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14804_64306)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00939941 0H60.0094V45H0.00939941V0Z",
    fill: "#3F9C35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00939941 0H60.0094V30H0.00939941V0Z",
    fill: "#ED2939"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00939941 0H60.0094V15H0.00939941V0Z",
    fill: "#00B9E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5 29.25C32.2279 29.25 35.25 26.2279 35.25 22.5C35.25 18.7721 32.2279 15.75 28.5 15.75C24.7721 15.75 21.75 18.7721 21.75 22.5C21.75 26.2279 24.7721 29.25 28.5 29.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 28.125C33.1066 28.125 35.625 25.6066 35.625 22.5C35.625 19.3934 33.1066 16.875 30 16.875C26.8934 16.875 24.375 19.3934 24.375 22.5C24.375 25.6066 26.8934 28.125 30 28.125Z",
    fill: "#ED2939"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 18.75L36.7219 20.7656L38.6531 19.8469L37.7344 21.7875L39.75 22.5L37.7344 23.2219L38.6531 25.1531L36.7219 24.2344L36 26.25L35.2781 24.2344L33.3469 25.1531L34.2656 23.2219L32.25 22.5L34.2656 21.7781L33.3469 19.8469L35.2781 20.7656L36 18.75Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14804_64306"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAz);
export default __webpack_public_path__ + "static/media/az.1e80e5e785e55222dd04c138367c192f.svg";
export { ForwardRef as ReactComponent };